import { IClientConfig } from '@front/interfaces/client-config.interface';
import { defaultConfig } from './default.config';

export const specsaversConfig: IClientConfig = {
  ...defaultConfig,
  name: 'Specsavers',
  logo: 'assets/images/logo-specsavers.svg',
  moduleAccess: {
    investment: true,
    modelTypeSwitch: true,
    examples: false,
    gapAnalysis: false,
    displayAvm: false,
    configurationAsClient: true,
    digitalFocus: false,
    effectiveness: true,
    channelPerformance: false,
    scenarios: true
  },
  wording: {
    ...defaultConfig.wording,
    turnover: 'Revenues',
    volume: 'Attended appointments'
  },
  aggregationWording: ['Division', 'Customer type', 'Product', 'Brand']
};
